import { render, staticRenderFns } from "./AlertCheck.vue?vue&type=template&id=231f3420&scoped=true&"
import script from "./AlertCheck.vue?vue&type=script&lang=js&"
export * from "./AlertCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f3420",
  null
  
)

export default component.exports